import * as React from 'react'
import { useMemo } from 'react'
import { CheckCircle, Loader2, Trash2Icon, XCircle } from 'lucide-react'

import { Button } from '@/components/ui/button.tsx'
import { useFileUpload } from '@/components/ui/extension/file-upload.tsx'
import { Progress } from '@/components/ui/progress.tsx'
import { UploadingFile } from '@/routes/_authenticated/documents/upload/-components/types.ts'

export const UploaderItem: React.FC<{
  uploadingFile: UploadingFile
  index: number
  onChange?: (file: UploadingFile) => void
  onRemove?: (file: UploadingFile) => void | Promise<void>
}> = ({ uploadingFile, index, onRemove }) => {
  const { removeFileFromSet } = useFileUpload()

  const handleRemoveClick = async () => {
    await onRemove?.(uploadingFile)

    removeFileFromSet(index)
  }

  const statusText = useMemo(() => {
    const dict: Record<UploadingFile['status'], string> = {
      idle: 'In attesa',
      uploading: 'Caricamento in corso',
      uploaded: 'Caricato',
      processing: 'In elaborazione',
      error: 'Errore',
    }

    return dict[uploadingFile.status]
  }, [uploadingFile.status])

  return (
    <div className="w-full rounded-md border p-4">
      <div className="mb-2 flex items-center justify-between">
        <p className="font-semibold">{uploadingFile.file.name}</p>

        <Button
          variant="link"
          size="icon"
          className="size-auto p-0 text-sm"
          onClick={handleRemoveClick}
        >
          <Trash2Icon />
        </Button>
      </div>
      <Progress value={uploadingFile.progress} className="my-2" />
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-x-1 text-sm capitalize text-gray-500">
          {uploadingFile.status === 'uploading' && (
            <Loader2 className="size-4 animate-spin" />
          )}
          {uploadingFile.status === 'processing' && (
            <Loader2 className="size-4 animate-spin" />
          )}
          {uploadingFile.status === 'uploaded' && (
            <CheckCircle className="size-4 text-green-500" />
          )}
          {uploadingFile.status === 'error' && (
            <XCircle className="size-4 text-red-500" />
          )}

          {statusText}
        </div>
      </div>
    </div>
  )
}
